import { Component, OnInit } from '@angular/core';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';

@Component({
	selector: 'app-unauthorized',
	templateUrl: './unauthorized.component.html',
	styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {

	constructor(
		private sideMenuService: SideMenuService
	) {
		this.sideMenuService.hide();
	}

	ngOnInit() {
	}
}
